// client/src/features/quotations/LineMatchActions.tsx
//
// D99 item 4: the two per-row actions on an amber (unconfirmed-match) line. WARN, NEVER BLOCK:
// neither action is required for anything. "Confirm" asks the server; "Change match" hands the
// line to the page's existing catalogue picker (no second picker here).

import React, { useState } from 'react';
import { confirmLineMatch, type QuotationItemDto } from '../../lib/quotationApi';
import { confirmRefusalMessage } from './lineMatchReview';

const BTN =
  "flex-shrink-0 whitespace-nowrap rounded border border-amber-300 bg-amber-50 px-[4px] font-['Public_Sans'] text-xs font-semibold leading-[14px] text-amber-800 hover:bg-amber-100 disabled:opacity-50";

export function LineMatchActions({
  quotationId,
  lineNumber,
  canConfirm = true,
  onConfirmed,
  onChangeMatch,
  onError,
}: {
  quotationId: string;
  lineNumber: number;
  /** `canConfirmMatch(line)`: false hides Confirm (the server would refuse); Change match stays. */
  canConfirm?: boolean;
  /** Receives the line exactly as the server now holds it. */
  onConfirmed: (line: QuotationItemDto) => void;
  onChangeMatch: () => void;
  /** Plain-English refusal for a toast. */
  onError: (message: string) => void;
}) {
  const [busy, setBusy] = useState(false);
  const confirm = async (e: React.MouseEvent) => {
    e.stopPropagation();
    setBusy(true);
    try {
      onConfirmed(await confirmLineMatch(quotationId, lineNumber));
    } catch (err: any) {
      onError(confirmRefusalMessage(err?.code));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      {canConfirm && (
        <button type="button" className={BTN} disabled={busy} onClick={confirm} title="Confirm this catalogue match is right">
          Confirm
        </button>
      )}
      <button
        type="button"
        className={BTN}
        onClick={(e) => {
          e.stopPropagation();
          onChangeMatch();
        }}
        title="Pick a different catalogue item for this line"
      >
        Change match
      </button>
    </>
  );
}

export default LineMatchActions;
